/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import Content from './Content/index'
import Footer from './Footer/index'
import Header from './Header/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content"
  
}) {
  return (<React.Fragment
>
<Header
  viewPath={`${viewPath}/Header`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
<Footer
  viewPath={`${viewPath}/Footer`}
/>
{children}
</React.Fragment>)
}